/* eslint-disable @typescript-eslint/no-require-imports */
import { Images } from "@src/images/Images";

export const resolveLogoForBrand = (brand: string): string => {
    switch (brand.toLowerCase()) {
        case "ktm":
            return require(`../assets/images/${Images.Logo_KTM.path}`);
        case "cfm":
            return require(`../assets/images/${Images.Logo_CFM.path}`);
        case "gg":
            return require(`../assets/images/${Images.Logo_GG.path}`);
        case "hqv":
            return require(`../assets/images/${Images.Logo_HQV.path}`);
        case "mva":
            return require(`../assets/images/${Images.Logo_MVA.path}`);
        case "wp":
            return require(`../assets/images/${Images.Logo_WP.path}`);
        default:
            return require(`../assets/images/${Images.Logo_PMAG.path}`);
    }
};
